import React, { useState, type FormEventHandler } from 'react';

import { Box } from '@clutter/clean';

import { NavLinkButton, Alert, Button, Panel } from '@shared/components/bootstrap';

import { InputFormGroup } from '@admin/components/fields/input_form_group';
import { TagsFormGroup } from '@admin/components/fields/tags_form_group';
import type { Redirect__Input } from '@admin/schema';

export const RedirectForm: React.FC<{
  loading: boolean;
  error?: string | null;
  save(input: Redirect__Input): void;
  defaults?: Redirect__Input;
}> = ({ loading, error, save, defaults }) => {
  const [slugs, setSlugs] = useState<string[]>(defaults?.slugs ?? []);
  const [targetURL, setTargetURL] = useState<string>(defaults?.targetURL ?? '');

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();

    save({
      slugs,
      targetURL,
    });
  };
  return (
    <form onSubmit={onSubmit}>
      <Panel>
        <Panel.Header>
          <Panel.Title>Redirect</Panel.Title>
        </Panel.Header>
        <Panel.Body>
          {error && <Alert style="danger">{error}</Alert>}

          <TagsFormGroup id="slugs" name="slugs" label="Slugs" placeholder="abcdef" value={slugs} onChange={setSlugs} />

          <InputFormGroup
            id="targetURL"
            name="targetURL"
            label="Target URL"
            placeholder="https://clutter.com"
            value={targetURL}
            onChange={(e) => setTargetURL(e.target.value)}
          />
        </Panel.Body>
        <Panel.Footer>
          <Box.Flex gap="4px" justifyContent="flex-end">
            <NavLinkButton to="/marketing/redirects">Cancel</NavLinkButton>
            <Button loading={loading} kind="primary" type="submit">
              Save
            </Button>
          </Box.Flex>
        </Panel.Footer>
      </Panel>
    </form>
  );
};
